import { initTinySlider } from '@stix/helpers';

// Header web component. Replaces Shopify.theme.sections.register('header', …).
// On the homepage it watches the hero to toggle the transparent header;
// everywhere it runs the top-bar announcement slider.
class HeaderSection extends HTMLElement {
  connectedCallback() {
    if (stix_api.theme.template.type === 'index') {
      this._initScrollObserver();
    }
    this._initSliders();
  }

  _initScrollObserver() {
    function onElementNearTop(element) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.boundingClientRect.bottom < 0) {
            document.body.classList.remove('transparent-header');
          } else {
            document.body.classList.add('transparent-header');
          }
        });
      }, { root: null, threshold: 0 });

      observer.observe(element);
    }
    const targetElement = document.querySelector("#hero");
    if (targetElement) onElementNearTop(targetElement);
  }

  _initSliders() {
    const options = {
      swipeAngle: 25,
      preventScrollOnTouch: true,
      center: true,
      nav: false,
      mouseDrag: false,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayButtonOutput: false,
      autoplayHoverPause: true,
      speed: 650
    };
    initTinySlider('top-bar', options);
  }
}

if (!customElements.get('header-section')) {
  customElements.define('header-section', HeaderSection);
}
